<app-header></app-header>

<div class="w-full max-w-7xl mx-auto px-2 md:px-0">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<app-base-toast></app-base-toast>
